import { DetailedAssetTable, FormItem, Space } from '../../../../../../components/core-v2'
import { AssetSummaryWithEconomics } from '../../types'

type Props = {
  assets?: AssetSummaryWithEconomics[]
  isFundOfFunds: boolean
}

export const PortfolioAssetList = ({ assets, isFundOfFunds }: Props) => (
  <Space mx={5} my={6}>
    Return and volatility calculations over last 12 months
    <FormItem>
      <DetailedAssetTable assets={assets} isFundOfFunds={isFundOfFunds} />
    </FormItem>
  </Space>
)
